// @flow

import React, { Fragment } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import {
  fontSize,
  spacing,
  borderRadius,
} from 'frontend_core/dist/styles/variables'
import { mediaMin } from 'frontend_core/dist/styles/media'
import { imagePath } from 'frontend_core/dist/helpers/image'
import Colors from 'components/styles/colors'
import Button from 'components/atoms/Button'

const ReservationEventBlockWrapper = styled.div`
  text-align: center;
  background-color: ${Colors.white};
  border: 1px solid ${Colors.grayE};
  border-radius: ${borderRadius}px;
`
const Content = styled.div`
  padding: ${spacing.medium_2}px ${spacing.medium_2}px 0;
  overflow: hidden;
`
const LogoImage = styled.img`
  height: 28px;
  ${mediaMin.phone`
    height: 26px;
  `} ${mediaMin.desktop`
    height: 28px;
  `};
`
const Desc = styled.pre`
  margin-top: ${spacing.small_2}px;
  color: ${Colors.gray9};
  font-size: ${fontSize.small}px;
  text-align: center;
  line-height: 1.416;
  white-space: pre-wrap;
`
const Title = styled.p`
  margin-top: ${spacing.small_3}px;
  font-size: ${fontSize.small_3}px;
  font-weight: bold;
  text-align: center;

  &:not(:first-of-type) {
    margin-top: ${spacing.small}px;
  }
`
const ThumbnailImage = styled.img`
  width: 100%;
  margin-top: ${spacing.medium}px;
  vertical-align: bottom;
  border-radius: ${borderRadius}px;
  box-shadow: 0 3px 9px 0 rgba(0, 0, 0, 0.15);
`
const ButtonWrapper = styled.div`
  padding: ${spacing.small_3}px;
  border-top: 1px solid ${Colors.grayE};
`

type PropTypes = {
  onClickEventServiceLp: Function,
}

export default function ReservationEventBlock(props: PropTypes) {
  return (
    <ReservationEventBlockWrapper>
      <Content>
        <LogoImage
          src={imagePath('logo_event.svg')}
          alt={i18n.t('spacemarket_event')}
        />
        <Title>{i18n.t('page.dashboard.inbox.eventGuide')}</Title>
        <Desc>{i18n.t('page.dashboard.inbox.aboutEvent')}</Desc>
        <ThumbnailImage
          src={imagePath('www/reserve/event_interface.png')}
          alt={i18n.t('spacemarket_event')}
        />
      </Content>
      <ButtonWrapper>
        {/* ToDo: イベント作成ページへリンクお願いします */}
        <Button
          tag="anchor"
          buttonType="medium"
          colorType="blue"
          fullWidthSp
          href="#"
          onClick={props.onClickEventServiceLp}
        >
          {i18n.t('page.dashboard.inbox.eventServiceLp')}
        </Button>
      </ButtonWrapper>
    </ReservationEventBlockWrapper>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/ReservationEventBlock/index.jsx